import { resolveOrgTimeZone } from "@/lib/ui/org";

export const TIMEZONE_COOKIE = "pinwiki_timezone";

export function parseTimeZone(raw: string | null | undefined): string | null {
  const zone = raw?.trim() ?? "";
  if (!zone || zone.length > 80) {
    return null;
  }
  try {
    Intl.DateTimeFormat("en-US", { timeZone: zone });
    return zone;
  } catch {
    return null;
  }
}

export function resolveDisplayTimeZone(
  cookie: string | null | undefined,
  orgTimeZone?: string | null,
): string {
  return parseTimeZone(cookie) ?? resolveOrgTimeZone(orgTimeZone);
}
